import { post, API_URL } from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

/**
 * 购买短信包
 * @param {Number} sms_count 购买数量 100 1000 5000
 */
export function taoke_sms_buy(sms_count) {
  return post('taoke_sms_buy', { sms_count })
}

/**
 * 短信使用记录 
 * @param {String} begin_time 时间开始 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 时间结束 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_sms_statis(data) {
  return post('taoke_sms_statis', data)
}

/**
 * 淘客签到插件设置
 * @param {Number} plugin_checkin_base_days 连续签到达成标准天数
 * @param {Number} plugin_checkin_base_below_money_range_min 连续签到未达成奖金金额范围下限
 * @param {Number} plugin_checkin_base_below_money_range_max 连续签到未达成奖金金额范围上限制
 * @param {Number} plugin_checkin_base_above_money 连续签到达成后奖金金额
 */
export function taoke_plugin_checkin_set(data) {
  return post('taoke_plugin_checkin_set', data)
}


/**
 * 淘客购买签到插件 
 * @param {Number} vip_time_length 购买时长(天) 30 90 365
 */
export function taoke_plugin_checkin_upgrade(data) {
  return post('taoke_plugin_checkin_upgrade', data)
}

/**
 * 淘客签到插件支出报表 
 * @param {String} begin_time 时间开始 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 时间结束 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_checkin_statis(data) {
  return post('taoke_plugin_checkin_statis', data)
}

/**
 * 淘客签到插件支出明细 
 * @param {String} begin_time 时间开始 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 时间结束 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_checkin_log(data) {
  return post('taoke_plugin_checkin_log', data)
}


/**
 * 淘客购买搜索到插件  
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_search_upgrade(data) {
  return post('taoke_plugin_search_upgrade', data)
}

/**
 * 淘客域名插件设置
 * @param {String} domain 需要设置的域名
 */
export function taoke_plugin_domain_set(data) {
  return post('taoke_plugin_domain_set', data)
}

/**
 * 淘客域名插件查询
 * @param {String} domain 需要设置的域名
 */
export function taoke_plugin_domain_query(data) {
  return post('taoke_plugin_domain_query', data)
}

/**
 * 淘客购买域名插件  
 * @param {String} vip_time_length 购买时长(月) 1
 */
export function taoke_plugin_domain_upgrade(data) {
  return post('taoke_plugin_domain_upgrade', data)
}


/**
 * 淘客官方红包插件设置 
 * @param {String} plugin_gfhb_title 标题
 * @param {String} plugin_gfhb_picture 图片 (使用picture_add接口上传图片后把地址传入)
 * @param {String} plugin_gfhb_ad_text 文案
 * @param {String} plugin_gfhb_content 领取内容
 * @param {String} plugin_gfhb_button_text 官方红包下方推荐文案
 * @param {String} plugin_gfhb_button_url 官方红包下方跳转链接
 * @param {String} plugin_gfhb_time_begin 开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} plugin_gfhb_time_end 结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_gfhb_set(data) {
  return post('taoke_plugin_gfhb_set', data)
}

/**
 * 淘客购买域名插件  
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_gfhb_upgrade(data) {
  return post('taoke_plugin_gfhb_upgrade', data)
}


/**
 * 推广小店
 * @param {String} plugin_tgxd_ad_text 标题
 */
export function taoke_plugin_tgxd_set(data) {
  return post('taoke_plugin_tgxd_set', data)
}


/**
 * 淘客购买域名插件  
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_tgxd_upgrade(data) {
  return post('taoke_plugin_tgxd_upgrade', data)
}

/**
 * 淘客购买提现红包插件 
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_txhb_upgrade(data) {
  return post('taoke_plugin_txhb_upgrade', data)
}

/**
 * 淘客提现红包插件领取日志 
 * @param {String} begin_time 开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_txhb_statis(data) {
  return post('taoke_plugin_txhb_statis', data)
}

/**
 * 淘客提现红包插件设置 
 * @param {String} day1 第一档 注册后的第几天内 不设置可以留0
 * @param {String} amount1 第一档 满足金额
 * @param {String} money1 第一档 可以奖励
 * @param {String} day2 第二档 注册后的第几天内 不设置可以留0
 * @param {String} amount2 第二档 满足金额
 * @param {String} money2 第二档 可以奖励
 * @param {String} day3 第三档 注册后的第几天内 不设置可以留0
 * @param {String} amount3 第三档 满足金额
 * @param {String} money3 第三档 可以奖励
 * @param {String} day4 第四档 注册后的第几天内 不设置可以留0
 * @param {String} amount4 第四档 满足金额
 * @param {String} money4 第四档 可以奖励
 */
export function taoke_plugin_txhb_set(data) {
  return post('taoke_plugin_txhb_set', data, { clear: false })
}
/**
 * 淘客提现红包插件领取明细
 * @param {String} begin_time 开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_txhb_log(data) {
  return post('taoke_plugin_txhb_log', data)
}


/**
 * 淘客提现红包插件设置
 * @param {String} plugin_wxlogin_wxappid 微信APPID
 * @param {String} plugin_wxlogin_wxappscrectkey 微信APPSCRE 
 * @param {String} plugin_wxlogin_wxauth_filename 微信“网页授权域名”安全设置文件txt（注意不要改名)）
 */
export function taoke_plugin_wxlogin_set(data) {
  const fd = new FormData()
  for (const key in data) {
    const val = data[key]
    if (val) {
      fd.append(key, val)
    }
  }
  fd.append('tsid', getToken())
  return axios.post(API_URL + '?do=taoke_plugin_wxlogin_set', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}

/**
 * 淘客购买CMS微信登录插件
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_wxlogin_upgrade(data) {
  return post('taoke_plugin_wxlogin_upgrade', data)
}

/**
 * 淘客购买零元购插件 
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_lyg_upgrade(data) {
  return post('taoke_plugin_lyg_upgrade', data)
}


/**
 * 淘客零元购插件规则设置 
 * @param {String} plugin_lyg_time_begin 零元购插件开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} plugin_lyg_time_end 零元购插件结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} plugin_lyg_newuser_coupon_amt 零元购插件新用户券面额
 * @param {String} plugin_lyg_olduser_coupon_amt 零元购插件老用户券面额
 * @param {String} plugin_lyg_coupon_quota 零元购插件总日领取限量
 * @param {String} plugin_lyg_olduser_coupon_quota 零元购插件老用户日领取限量
 * @param {String} plugin_lyg_use_limit_days 零元购插件天数限制（和零元购插件次数限制配合）,不限制请设置为0
 * @param {String} plugin_lyg_use_limit_times 零元购插件次数限制（和零元购插件天数限制配合）,不限制请设置为0
 * @param {String} plugin_lyg_taobao_auth 零元购插件使用限制，需要淘宝授权 0不需要 1需要
 */
export function taoke_plugin_lyg_rule_set(data) {
  return post('taoke_plugin_lyg_rule_set', data)
}

/**
 * 淘客零元购插件宣传页设置 
 * @param {String} plugin_lyg_bgimg 零元购插件背景图
 * @param {String} plugin_lyg_ad_text 零元购插件引导文案
 * @param {String} plugin_lyg_ad_rule 零元购插件规则
 */
export function taoke_plugin_lyg_ad_set(data) {
  return post('taoke_plugin_lyg_ad_set', data)
}


/**
 * 淘客零元购插件锁券（券必须状态为0） 
 * @param {String} id 优惠券id
 */
export function taoke_plugin_lyg_coupon_lock(data) {
  return post('taoke_plugin_lyg_coupon_lock', data)
}

/**
 * 淘客零元购插件解锁券 
 * @param {String} id 优惠券id
 */
export function taoke_plugin_lyg_coupon_unlock(data) {
  return post('taoke_plugin_lyg_coupon_unlock', data)
}

/**
 * 淘客零元购插件券统计   
 * @param {String} begin_time 开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_lyg_statis(data) {
  return post('taoke_plugin_lyg_statis', data)
}

/**
 * 淘客零元购插件淘客主动发券 
 * @param {String} telephone 想要发券的cms会员的手机号码，可以输入多个号码，,隔开即可
 * @param {String} count 数量(每人)
 * @param {String} price 券面额
 */
export function taoke_plugin_lyg_coupon_send(data) {
  return post('taoke_plugin_lyg_coupon_send', data)
}

/**
 * 淘客购买CMS超级秒杀插件
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_xsms_upgrade(data) {
  return post('taoke_plugin_xsms_upgrade', data)
}

/**
 * 淘客后台秒杀插件设置接口 
 * @param {String} plugin_xsms_item_source 商品来源 1淘客自选 2官方托管 3自选+托管
 * @param {String} plugin_xsms_use_limit_day 限制购买几天内
 * @param {String} plugin_xsms_use_limit_num 限制购买几天内的次数
 * @param {String} plugin_xsms_reward_lock_day 返现锁定期
 */
export function taoke_plugin_xsms_set(data) {
  return post('taoke_plugin_xsms_set', data)
}


/**
 * 淘客后台秒杀商品添加 
 * @param {String} item_id 淘宝商品id
 * @param {String} reward 额外返现默认0.00
 * @param {String} num 限量供应多少 默认1
 * @param {String} only_new_member 是否限制新用户 1是 0否 默认0
 * @param {String} agent_member 是否允许代理 1是 0否 默认0
 * @param {String} normal_member 是否允许普通用户 1是 0否 默认0
 * @param {String} start_time 开始秒杀时间 Y-m-d H:i:s
 * @param {String} end_time 结束秒杀时间 Y-m-d H:i:s
 */
export function taoke_plugin_xsms_items_add(data) {
  return post('taoke_plugin_xsms_items_add', data)
}

/**
 * 淘客后台秒杀插件秒杀商品编辑 
 * @param {String} id 秒杀商品表的id
 * @param {String} reward 额外返现默认0.00
 * @param {String} num 限量供应多少 默认1
 * @param {String} only_new_member 是否限制新用户 1是 0否 默认0
 * @param {String} agent_member 是否允许代理 1是 0否 默认0
 * @param {String} normal_member 是否允许普通用户 1是 0否 默认0
 * @param {String} start_time 开始秒杀时间 Y-m-d H:i:s
 * @param {String} end_time 结束秒杀时间 Y-m-d H:i:s
 */
export function taoke_plugin_xsms_items_edit(data) {
  return post('taoke_plugin_xsms_items_edit', data)
}


/**
 * 淘客后台秒杀商品删除
 * @param {String} id 秒杀商品表的id
 */
export function taoke_plugin_xsms_items_del(data) {
  return post('taoke_plugin_xsms_items_del', data)
}

/**
 * 淘客后台超级秒杀列表 
 * @param {Number} [page=1] 页码
 * @param {Number} [pagesize=10] 分页大小
 */
export function taoke_plugin_xsms_items_list(data) {
  return post('taoke_plugin_xsms_items_list', data)
}

/**
 * 淘客后台秒杀商品添加
 * @param {Number} taobao_url 淘宝原始链接
 */
export function taoke_plugin_xsms_items_query(data) {
  return post('taoke_plugin_xsms_items_query', data)
}

/**
 * 淘客后台秒杀插件统计接口
 * @param {String} begin_time 开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} end_time 结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 */
export function taoke_plugin_xsms_statis(data) {
  return post('taoke_plugin_xsms_statis', data)
}

/**
 * 淘客后台超级秒杀解除禁用  
 * @param {String} id 秒杀记录id
 */
export function taoke_plugin_xsms_records_unlock(data) {
  return post('taoke_plugin_xsms_records_unlock', data)
}

/**
 * 淘客后台超级秒杀禁用 
 * @param {String} id 秒杀记录id
 */
export function taoke_plugin_xsms_records_lock(data) {
  return post('taoke_plugin_xsms_records_lock', data)
}







/**
 * 淘客购买限时抢购插件 
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_flashsale_upgrade(data) {
  return post('taoke_plugin_flashsale_upgrade', data)
}

/* 返利机器人接口 */
/**
 * 淘客购买返利机器人插件 
 * @param {String} vip_time_length 购买时长(月) 1 3 12
 */
export function taoke_plugin_fljqr_upgrade(data) {
  return post('taoke_plugin_fljqr_upgrade', data)
}

/**
 * 返利机器人会员列表 
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function taoke_plugin_fljqr_account_list(data) {
  return post('taoke_plugin_fljqr_account_list', data)
}

/**
 * 返利机器人插件设置 
 * @param {String} ad_text 公告内容
 */
export function taoke_plugin_fljqr_set(data) {
  return post('taoke_plugin_fljqr_set', data)
}

/**
 * 淘客返利机器人插件数据分组 
 */
export function taoke_plugin_fljqr_group_list(data) {
  return post('taoke_plugin_fljqr_group_list', data)
}

/**
 * 淘客念初返利机器人插件数据分组
 */
export function taoke_plugin_nianchu_group_list(data) {
  return post('taoke_plugin_nianchu_group_list', data)
}

/**
 * 念初返利机器人插件，会员列表
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 * @param {String} wx_id 微信id
 * @param {String} group_id 机器人id
 */
export function taoke_plugin_nianchu_account_list(data) {
  return post('taoke_plugin_nianchu_account_list', data)
}

/**
 * 淘客念初返利机器人插件增加数据分组
 * @param {String} main_id 主账号id
 * @param {String} sub_id 子账号id
 * @param {String} group_name 机器人名字
 */
export function taoke_plugin_nianchu_group_add(data) {
  return post('taoke_plugin_nianchu_group_add', data)
}

/**
 * 淘客念初返利机器人插件增加数据分组
 * @param {String} id 机器人id
 */
export function taoke_plugin_nianchu_group_del(data) {
  return post('taoke_plugin_nianchu_group_del', data)
}






/* 返利机器人接口 -end */


/* 服务号消息接口 */

/**
 * 购买服务号消息插件
 * @param {String} vip_time_length 购买时长
 */
export function taoke_plugin_wxlogin_tmpmsg_upgrade(data) {
  return post('taoke_plugin_wxlogin_tmpmsg_upgrade', data)
}

/**
 * 购买服务号消息插件
 * @param {String} plugin_wxlogin_tmpmsg_neworder 新订单推送模板ID
 * @param {String} plugin_wxlogin_tmpmsg_withdraw  提现完成推送模板ID
 */
export function taoke_plugin_wxlogin_tmpmsg_set(data) {
  return post('taoke_plugin_wxlogin_tmpmsg_set', data)
}


/* 服务号消息接口 -end */

/* 微信自动回复插件接口 */

/**
 * 购买服务号消息插件
 * @param {String} vip_time_length 购买时长
 */
export function taoke_plugin_wxautoreply_upgrade(data) {
  return post('taoke_plugin_wxautoreply_upgrade', data)
}

/**
 * 淘客CMS微信自动回复插件设置
 * @param {String} gzh_id 公众号原始ID
 * @param {String} reset_token  重置token 1重置，0不重置
 */
export function taoke_plugin_wxautoreply_set(data) {
  return post('taoke_plugin_wxautoreply_set', data)
}

/**
 * 淘客CMS微信自动回复插件信息
 * @param {String} tsid 
 */
export function taoke_plugin_wxautoreply_info(data) {
  return post('taoke_plugin_wxautoreply_info', data)
}
/**
 * 淘客微信公众号关注自动回复插件配置渠道红包
 * @param {String} plugin_wxautoreply_redpacket_status 公众号注册渠道专属红包开启状态 1：开启 0：关闭
 * @param {String} plugin_wxautoreply_redpacket_fiexd_money 公众号注册渠道专属固定金额红包
 * @param {String} plugin_wxautoreply_redpacket_range_money 公众号注册渠道专属随机金额红包示例：5-10 
 */
export function taoke_plugin_wxautoreply_redpacket_set(data) {
  return post('taoke_plugin_wxautoreply_redpacket_set', data)
}
/**
 * 淘客微信公众号关注自动回复插件渠道红包领取记录
 * @param {String} telephone 手机号（注册人）
 * @param {String} nickname 昵称
 * @param {String} reg_start_time 注册开始时间 （格式如: 2018-12-17 00:00:00）
 * @param {String} reg_end_time 注册结束时间 （格式如: 2018-12-17 00:00:00）
 * @param {String} order_type 排序方式 1 领取时间 2余额倒叙 3余额正序 
 */
export function taoke_plugin_wxautoreply_redpacket_list(data) {
  return post('taoke_plugin_wxautoreply_redpacket_list', data)
}

/**
 * 淘客配置微信公众号菜单和关键词回复数据添加
 * @param {String} q 检索关键词，前后加%%表示模糊查询比如，男装，或者%男装%
 * @param {String} data 自动回复文本
 * @param {String} picture_media 自动回复图片文件 * 
 */
export function taoke_plugin_wxautoreply_menu_data_add(data) {
  return post('taoke_plugin_wxautoreply_menu_data_add', data, {
    config: {
      transformRequest: [(data) => {
        // data => formdata
        let formD = new FormData();
        Object.keys(data).forEach((key) => {
          if (data[key] !== null) {
            formD.append(key, data[key])
          }
        })
        return formD
      }],
    },
  })
}

/**
 * 淘客配置微信公众号菜单
 * @param {String} tsid 
 * @param {String} menu_data 菜单数据 格式直接使用https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1455782296这个上面的官方格式（KEY需要使用taoke_plugin_wxlogin_tmpmsg_menudata_set的返回值）
 */
export function taoke_plugin_wxautoreply_menu_set(data) {
  return post('taoke_plugin_wxautoreply_menu_set', data)
}

/**
 * 淘客配置微信公众号菜单数据查看
 * @param {String} tsid 
 * @param {String} key 菜单数据 格式直接使用https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1455782296这个上面的官方格式（KEY需要使用taoke_plugin_wxlogin_tmpmsg_menudata_set的返回值）
 */
export function taoke_plugin_wxautoreply_menu_data_info(data) {
  return post('taoke_plugin_wxautoreply_menu_data_info', data)
}

/**
 * 淘客配置微信公众号菜单和关键词回复数据添加
 * @param {String} q 检索关键词，前后加%%表示模糊查询比如，男装，或者%男装%
 * @param {String} data 自动回复文本
 * @param {String} picture_media 自动回复图片文件 * 
 */
export function taoke_plugin_wxautoreply_menu_data_edit(data) {
  return post('taoke_plugin_wxautoreply_menu_data_edit', data, {
    config: {
      transformRequest: [(data) => {
        // data => formdata
        let formD = new FormData();
        Object.keys(data).forEach((key) => {
          if (data[key] !== null) {
            formD.append(key, data[key])
          }
        })
        return formD
      }],
    },
  })
}

/**
 * 淘客配置微信公众号菜单和关键词回复数据添加
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function taoke_plugin_wxautoreply_menu_data_list(data) {
  return post('taoke_plugin_wxautoreply_menu_data_list', data)
}

/**
 * 淘客配置微信公众号菜单和关键词回复数据添删除
 * @param {String} id id
 */
export function taoke_plugin_wxautoreply_menu_data_delete(data) {
  return post('taoke_plugin_wxautoreply_menu_data_delete', data)
}


/* 微信自动回复插件接口 -end */

/* app配置接口 -start */

/**
 * 淘客购买导购APP插件
 * @param {String} vip_time_length 购买时长
 */
export function taoke_plugin_app_upgrade(data) {
  return post('taoke_plugin_app_upgrade', data)
}

/**
 * 淘客配置(申请开发)导购APP插件（主信息）
 * @param {String} app_name app名字
 * @param {String} app_icon app图标
 * @param {String} app_app_introduce app简介
 * @param {String} baichuan_app_key 百川appkey
 * @param {String} ios_bundle_id  ios bundleid
 * @param {String} android_market  android_market
 * @param {String} android_package_name  包名
 */
export function taoke_plugin_app_main_set(data) {
  return post('taoke_plugin_app_main_set', data)
}

/**
 * 淘客配置导购APP插件（样式）
 * @param {String} main_color 主色调 1经典 2活力橙 3热情紫
 * @param {String} main_theme 主样式 1经典 2卡片
 * @param {String} app_theme  模板id
 */
export function taoke_plugin_app_style_set(data) {
  return post('taoke_plugin_app_style_set', data)
}

/**
 * 淘客导购APP信息
 */
export function taoke_plugin_app_info(data) {
  return post('taoke_plugin_app_info', data)
}

/**
 * 淘客配置导购APP插件,发布演示地址设置
 * @param {String} android_demo_url 
 * @param {String} ios_demo_url 
 */
export function taoke_plugin_app_demo_url_set(data) {
  return post('taoke_plugin_app_demo_url_set', data)
}

/**
 * 淘客配置导购APP插件,新增版本记录
 * @param {String} platform 
 * @param {String} ver
 * @param {String} changelog
 */
export function taoke_plugin_app_changelog_set(data) {
  return post('taoke_plugin_app_changelog_set', data)
}

/**
 * 淘客配置导购APP插件,淘客导购APP发布状态标记
 * @param {String} market 
 * @param {String} ver
 * @param {String} status
 */
export function taoke_plugin_app_apply_set(data) {
  return post('taoke_plugin_app_apply_set', data)
}

/**
 * 新增app模板
 * @param {String} name
 * @param {String} value
 * @param {String} thum_image
 */
export function taoke_plugin_app_theme_add(data) {
  return post('taoke_plugin_app_theme_add', data)
}

/**
 * 编辑app模板
 * @param {String} id
 * @param {String} name
 * @param {String} value
 * @param {String} thum_image
 */
export function taoke_plugin_app_theme_edit(data) {
  return post('taoke_plugin_app_theme_edit', data)
}

/**
 * 删除app模板
 * @param {String} id
 */
export function taoke_plugin_app_theme_delete(data) {
  return post('taoke_plugin_app_theme_delete', data)
}

// /**
//  * 选择app模板
//  * @param {String} id
//  */
// export function taoke_plugin_app_style_set(data) {
//   return post('taoke_plugin_app_style_set', data)
// }

/**
 * app模板列表
 */
export function taoke_plugin_app_theme_list(data) {
  return post('taoke_plugin_app_theme_list', data)
}


/* app配置接口 -end */

/* app管理中心接口 -start */
/**
管理员设置导购APP版本信息
 */
export function admin_plugin_app_version(data) {
  return post('admin_plugin_app_version', data)
}
/**
 * appinfo
 * @param {String} id 
 */
export function admin_plugin_app_info(data) {
  return post('admin_plugin_app_info', data)
}

/**
 * appinfo
 * @param {String} id 
 */
export function admin_plugin_app_info2(data) {
  return post('admin_plugin_app_info2', data)
}

/**
 * 设置激活模板
 * @param {String} id 
 */
export function admin_plugin_app_style_set(data) {
  return post('admin_plugin_app_style_set', data)
}
/**
 * 删除app模板
 * @param {String} id 
 */
export function admin_plugin_app_theme_delete(data) {
  return post('admin_plugin_app_theme_delete', data)
}

/**
 * 编辑app模板
 * @param {String} id
 * @param {String} name
 * @param {String} value
 * @param {String} thum_image
 */
export function admin_plugin_app_theme_edit(data) {
  return post('admin_plugin_app_theme_edit', data)
}
/**
 * app模板列表
 */
export function admin_plugin_app_theme_list(data) {
  return post('admin_plugin_app_theme_list', data)
}

/**
 * 新增app模板
 * @param {String} name
 * @param {String} value
 * @param {String} thum_image
 */
export function admin_plugin_app_theme_add(data) {
  return post('admin_plugin_app_theme_add', data)
}




/* app管理中心接口 -end */

/* 插件排行接口 -start*/

export function taoke_plugin_list(data) {
  return post('taoke_plugin_list', data)
}

/* 插件排行接口 -end  */

/* 微信小程序插件接口 -start */
/**
 * 淘客小程序授权信息保存
 * @param authorization_code 授权码
 */
export function taoke_plugin_wxapp_auth_info_save(data) {
  return post('taoke_plugin_wxapp_auth_info_save', data)
}

/**
 * 淘客小程序授权通知
 */
export function taoke_plugin_wxapp_check_notice(data) {
  return post('taoke_plugin_wxapp_check_notice', data)
}

/**
 * 获取授权链接
 */
export function taoke_plugin_wxapp_get_auth_url(data) {
  return post('taoke_plugin_wxapp_get_auth_url', data)
}

/**
 * 淘客小程序信息
 */
export function taoke_plugin_wxapp_info(data) {
  return post('taoke_plugin_wxapp_info', data)
}

/**
 * 淘客微信小程序插件设置
 */

/**
 * 淘客购买小程序插件
 * @param vip_time_length
 */
export function taoke_plugin_wxapp_upgrade(data) {
  return post('taoke_plugin_wxapp_upgrade', data)
}

/**
 * 淘客小程序微信推送消息接口
 * @param appid
 */
export function taoke_plugin_wxappopen_api(data) {
  return post('taoke_plugin_wxappopen_api', data)
}

/**
 * 小程序banner增加
 * @param url
 * @param picture
 * @param type
 */
export function taoke_wxapp_banner_recommend_add(data) {
  return post('taoke_wxapp_banner_recommend_add', data)
}

/**
 * 小程序banner删除
 * @param id
 */
export function taoke_wxapp_banner_recommend_delete(data) {
  return post('taoke_wxapp_banner_recommend_delete', data)
}

/**
 * 小程序banner修改
 * @param id
 * @param url
 * @param picture
 */
export function taoke_wxapp_banner_recommend_edit(data) {
  return post('taoke_wxapp_banner_recommend_edit', data)
}

/**
 * 小程序banner列表
 * @param type
 */
export function taoke_wxapp_banner_recommend_list(data) {
  return post('taoke_wxapp_banner_recommend_list', data)
}

/**
 * 小程序banner列表
 * @param id_order_str
 */
export function taoke_wxapp_banner_recommend_order_set(data) {
  return post('taoke_wxapp_banner_recommend_order_set', data)
}
/**
 * 获取淘客微信小程序二维码
 * @param wxapp_id
 */
export function taoke_plugin_wxapp_getqrcode(data) {
  return post('taoke_plugin_wxapp_getqrcode', data)
}
/* 微信小程序插件接口 -end */






